module.exports = __webpack_public_path__ + "img/logo-bg-blue.3f83626d.png";